<template>
    <form id="add-weight-measurement-form" v-on:submit.prevent="submitForm">
        <div class="modal-body">
            <div v-if="errorMessage" class="alert alert-danger" role="alert">Något har gått fel...</div>

            <div class="input-group date flex add-measurement-date">
                <label>Datum</label>
                <input type="text" name="Datum" value="" id="add-measurement-date" class="form-control" />
                <span class="input-group-addon">
                    <span class="glyphicon glyphicon-calendar"></span>
                </span>
            </div>

            <div class="form-group flex">
                <label for="add-weight">Vikt (kg)</label>
                <input
                    type="number"
                    value=""
                    min="0"
                    step=".1"
                    size="6"
                    maxlength="6"
                    class="form-control"
                    id="add-weight"
                    name="Vikt"
                />
            </div>

            <div class="form-group flex">
                <label for="add-waist">Midjemått (cm)</label>
                <input
                    type="number"
                    value=""
                    min="0"
                    step=".1"
                    size="6"
                    maxlength="6"
                    class="form-control"
                    id="add-waist"
                    name="Midjematt"
                />
            </div>

            <div class="form-group flex">
                <label for="add-hip">Höftmått (cm)</label>
                <input
                    type="number"
                    min="0"
                    step=".1"
                    value=""
                    size="6"
                    maxlength="6"
                    class="form-control"
                    id="add-hip"
                    name="Hoftmatt"
                />
            </div>

            <div class="form-group flex">
                <label for="add-bodyfat">Kroppsfett (%)</label>
                <input
                    type="number"
                    min="0"
                    step=".1"
                    value=""
                    size="6"
                    maxlength="4"
                    class="form-control"
                    id="add-bodyfat"
                    name="Kroppsfett"
                />
            </div>

            <div class="form-group flex">
                <label for="add-cholesterol">Kolesterol</label>
                <input
                    type="number"
                    min="0"
                    step=".1"
                    value=""
                    size="6"
                    maxlength="4"
                    class="form-control"
                    id="add-cholesterol"
                    name="Kolesterol"
                />
            </div>

            <div class="form-group flex">
                <label for="add-bukhozd">Bukhöjd (cm)</label>
                <input
                    type="number"
                    min="0"
                    step=".1"
                    value=""
                    size="6"
                    maxlength="4"
                    class="form-control"
                    id="add-bukhozd"
                    name="Bukhojd"
                />
            </div>

            <div class="form-group flex">
                <label for="add-blood-pressure-over">Blodtryck (mmHg) - Systoliskt (övre)</label>
                <input
                    type="number"
                    min="0"
                    step=".1"
                    value=""
                    size="6"
                    maxlength="4"
                    class="form-control"
                    id="add-blood-pressure-over"
                    name="BlodtryckOvre"
                />
            </div>

            <div class="form-group flex">
                <label for="add-blood-pressure-under">Blodtryck (mmHg) - Diastoliskt (undre)</label>
                <input
                    type="number"
                    min="0"
                    step=".1"
                    value=""
                    size="6"
                    maxlength="4"
                    class="form-control"
                    id="add-blood-pressure-under"
                    name="BlodtryckUndre"
                />
            </div>

            <div class="form-group flex">
                <label for="resting-pulse">Vilopuls (slag/minut)</label>
                <input
                    type="number"
                    min="0"
                    value=""
                    size="6"
                    maxlength="4"
                    class="form-control"
                    id="resting-pulse"
                    name="Vilopuls"
                />
            </div>

            <div class="form-group flex">
                <label for="none-body-fat">Fettfri kroppsvikt (kg)</label>
                <input
                    type="number"
                    min="0"
                    step=".1"
                    value=""
                    size="6"
                    maxlength="4"
                    class="form-control"
                    id="none-body-fat"
                    name="FettfriKroppsvikt"
                />
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Stäng</button>
            <button type="submit" class="btn btn-success">
                {{ state.isEditMode ? 'Spara' : 'Lägg till' }}
            </button>
            <button v-if="state.isEditMode" v-on:click.prevent="remove" type="button" class="btn btn-danger">
                Radera
            </button>
        </div>
    </form>
</template>

<script>
import axios from 'axios';

import state from './../state.js';

import bootbox from 'bootbox';

export default {
    data() {
        return {
            state,
            errors: [],
            isEditMode: false,
            errorMessage: false
        };
    },

    mounted() {
        let params = new URL(document.location).searchParams;
        this.errorMessage = false;

        $('#add-weight-measurement').on('hide.bs.modal', (e) => {
            this.errors = [];
            this.resetErrorsClass();
            params.delete('edit');
            window.history.pushState({}, document.title, window.location.pathname);
        });

        $('#add-weight-measurement').on('show.bs.modal', (e) => {
            this.errors = [];
            this.resetErrorsClass();

            if (params.get('edit')) {
                this.state.isEditMode = true;
                let id = params.get('id');

                axios
                    .get('/api/get-weight-measurement/' + id)
                    .then((response) => {
                        if (response.data) {
                            for (const [key, value] of Object.entries(response.data)) {
                                $('#add-weight-measurement-form input[name="' + key + '"]').val(value);
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                this.state.isEditMode = false;
                document.getElementById('add-weight-measurement-form').reset();
                this.setTodayDate();
            }
        });

        if (params.get('edit')) {
            this.state.isEditMode = true;
            $('#add-weight-measurement').modal('show');
        }
    },

    methods: {
        submitForm: function (e) {
            const form = document.getElementById('add-weight-measurement-form');
            let params = new URL(document.location).searchParams;
            let inputs = {};
            this.errors = [];
            this.errorMessage = false;

            for (let field of form.elements) {
                if (field.name === 'Datum' || field.name === 'Vikt') {
                    if (field.value.length === 0) {
                        if (field.id.length) {
                            this.errors.push(field.id);
                        }
                    } else {
                        this.errors = [];
                    }
                }
            }

            if (this.errors.length === 0) {
                for (let field of form.elements) {
                    if (field.value) {
                        document.getElementById(field.id).classList.remove('error');
                        inputs[field.name] = field.value;
                    }
                }

                const endpoint = this.state.isEditMode
                    ? '/api/update-weight-measurement/' + params.get('id')
                    : '/api/add-weight-measurement';

                axios
                    .post(endpoint, {
                        inputs: inputs
                    })
                    .then((response) => {
                        if (response.data) {
                            if (response.data.message === 'error') {
                                this.errorMessage = true;
                                setTimeout(() => (this.errorMessage = false), 3000);
                                return;
                            }

                            if (!this.state.isEditMode) {
                                this.state.measurements.unshift(response.data.value);
                                form.reset();
                                this.setTodayDate();
                            }

                            if (this.state.isEditMode) {
                                params.delete('edit');
                                params.delete('id');
                                window.history.pushState({}, document.title, window.location.pathname);

                                window.location.reload();
                                this.state.isEditMode = false;
                            }

                            $('#add-weight-measurement').modal('toggle');
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                for (let id of this.errors) {
                    let el = document.getElementById(id);
                    el.classList.add('error');
                }
            }
        },

        remove: function () {
            bootbox
                .confirm({
                    message: 'Är du säker på att du vill ta bort denna dagen?',
                    callback: (result) => {
                        if (result) {
                            let params = new URL(document.location).searchParams;

                            axios
                                .get('/api/delete-weight-measurement/' + params.get('id'))
                                .then((response) => {
                                    params.delete('edit');
                                    params.delete('id');
                                    window.history.pushState({}, document.title, window.location.pathname);

                                    window.location.reload();
                                    this.state.isEditMode = false;

                                    $('#add-weight-measurement').modal('toggle');
                                })
                                .catch((error) => {
                                    console.log(error);
                                });
                        }
                    }
                })
                .init(function () {
                    $('.modal-footer .btn.btn-primary').text('Radera');
                    $('.modal-footer .btn.btn-default').text('Avbryt');
                });
        },

        setTodayDate: function () {
            let options = { year: 'numeric', month: 'numeric', day: 'numeric' };
            let today = new Date();

            document.getElementById('add-measurement-date').value = today.toLocaleDateString(
                'sv-SE',
                options
            );
        },

        resetErrorsClass: function () {
            for (let field of document.getElementById('add-weight-measurement-form').elements) {
                if (field.id) {
                    document.getElementById(field.id).classList.remove('error');
                }
            }
        }
    }
};
</script>
